/**
 * Decodes HTML entities in a string
 * @param str - String containing HTML entities
 * @returns Decoded string
 */
export const decodeHtmlEntities = (str: string): string => {
  if (typeof str !== 'string') return str;
  
  try {
    // Use DOMParser for safe HTML entity decoding - prevents XSS
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${str}</div>`, 'text/html');
    
    // Extract text content, which automatically decodes entities safely
    let textContent = doc.body.textContent || doc.body.innerText || '';
    
    // Fix common encoding corruption where é becomes 9
    textContent = fixCorruptedCharacters(textContent);
    
    return textContent;
  } catch (DOMException) {
    // Fallback: return original string if parsing fails
    return fixCorruptedCharacters(str);
  }
};

/**
 * Fix common character encoding corruptions
 */
const fixCorruptedCharacters = (text: string): string => {
  if (typeof text !== 'string') return text;
  
  // Fix é being replaced with 9 in common French words
  return text
    .replace(/ann9e/g, 'année')
    .replace(/compe9titifs/g, 'compétitifs')  
    .replace(/diffe9rentes/g, 'différentes')
    .replace(/e9/g, 'é')  // General fix for é -> 9 corruption
    .replace(/a8/g, 'à')  // Fix à -> 8 corruption
    .replace(/e7/g, 'è')  // Fix è -> 7 corruption
    .replace(/o6/g, 'ô')  // Fix ô -> 6 corruption
    .replace(/u5/g, 'ù')  // Fix ù -> 5 corruption
    .replace(/i4/g, 'î')  // Fix î -> 4 corruption
    .replace(/a3/g, 'â')  // Fix â -> 3 corruption
    .replace(/e2/g, 'ê')  // Fix ê -> 2 corruption
    .replace(/c1/g, 'ç')  // Fix ç -> 1 corruption
    .replace(/o0/g, 'ö'); // Fix ö -> 0 corruption
};